export default "__VITE_ASSET__DWQ19tUS__"